import { gql } from '@apollo/client';

export const DELETE_ROTATIONSPLAN_VORLAGE = gql`
  mutation mitarbeiter_deleteRotationsplanVorlage($vorlageId: String!) {
    mitarbeiter_deleteRotationsplanVorlage(vorlageId: $vorlageId) {
      success {
        vorlageId
      }
      error {
        message
      }
    }
  }
`;
